import { INKLE_WEBSITE_URL } from "./base";

export const INKLE_PRICING_URL = `${INKLE_WEBSITE_URL}pricing`;
export const INKLE_BOOKS_PRICING_URL = `${INKLE_WEBSITE_URL}pricing#inkle-books`;
export const INKLE_TAX_PRICING_URL = `${INKLE_WEBSITE_URL}pricing#Inkle%20Tax`;
